// extracted by mini-css-extract-plugin
export default {"adminContainer":"AdminsViewPage_adminContainer__F-mBL"};